<div class="h-full min-h-0 overflow-y-auto p-4">
	<div class="flex gap-2 items-center justify-between mb-4">
		<h3 class="text-lg font-semibold text-slate-700">Tus sesiones activas</h3>
		<app-button
			label="Cerrar todas las sesiones"
			icon="bi bi-box-arrow-right"
			variant="danger"
			size="sm"
			(onClick)="confirmarCerrarTodas()"
			[disabled]="sesiones().length === 0"
		/>
	</div>

	<app-tabla [datos]="sesiones()" [columnas]="columnas" [loading]="loading()" [accionesTemplate]="acciones">
		<ng-template #acciones let-row>
			@if (row.estado_activo) {
				<div class="flex gap-1 justify-center">
					<app-button
						icon="bi bi-x-circle"
						variant="danger"
						[rounded]="true"
						(onClick)="cerrarSesion(row)"
						appTooltip="Cerrar esta sesion"
						tooltipPosition="left"
					/>
					<app-button
						icon="bi bi-shield-x"
						variant="warning"
						[rounded]="true"
						(onClick)="cerrarOtrasSesiones(row)"
						appTooltip="Cerrar todas las demas"
						tooltipPosition="left"
					/>
				</div>
			}
		</ng-template>
	</app-tabla>

	<app-dialog
		header="Cerrar todas las sesiones"
		[modal]="true"
		[(visible)]="modalCerrarTodas"
		size="xs"
		styleClass="w-[400px]"
	>
		<p class="text-slate-600 mb-4">Se cerraran todas tus sesiones y deberas iniciar sesion nuevamente.</p>
		<div class="flex justify-end gap-2">
			<app-button label="Cancelar" variant="secondary" (onClick)="modalCerrarTodas.set(false)" />
			<app-button label="Cerrar todas" variant="danger" (onClick)="cerrarTodasSesiones()" />
		</div>
	</app-dialog>
</div>
